// Defensive label utility shared by the audit table and the Actions
// facet popover.
//
// The indexer renders human_label by substituting catalog placeholders
// (e.g. `{camera_count}`) with values from `human_label_params_json`. If
// a parameter is missing — historical write, schema drift, manual catalog
// edit — the unsubstituted brace would leak into the user-facing audit
// row as literal "{camera_count}". This stripper hides the leak so the
// data still reads cleanly. New event templates should never depend on
// this fallback; it's a safety net.

/**
 * Strip any unsubstituted `{placeholder}` tokens out of a rendered
 * human_label and tidy up the dangling " · " separators that the templates
 * use as soft delimiters. Also drops a small set of known orphaned
 * unit-words that the catalog used to leave behind a count placeholder
 * (e.g. "Started Live View · {camera_count} cameras" → catalog change
 * removed the placeholder but historical OS docs still carry the noun).
 */
const ORPHANED_UNIT_WORDS = /\s*·\s*(cameras?|users?|files?|items?)\s*$/i;

export function cleanLabel(label: string): string {
  if (!label) return label;
  return label
    .replace(/\{[a-z0-9_]+\}/gi, "")
    .replace(ORPHANED_UNIT_WORDS, "")
    .replace(/·\s*$/, "")
    .replace(/\s+·\s*/g, " · ")
    .trim();
}
